import { BackgroundText, ContentWithLink, HomeHeader, HomePageHero, Logos, MeetTheTeam, NavBarColorSwitcher, Spacer, Words } from "components";
import planning from "images/team-images/planning.jpg";
import sofa2 from "images/team-images/sofa2.png";
import tnbt from "images/client-logos/tnbt.svg";
import wpserved from "images/client-logos/wpserved.svg";
import wupwt from "images/client-logos/wupwt.png";
import insanelab from "images/client-logos/insanelab.svg";
import gpd from "images/client-logos/gpd.svg";
import fusebox from "images/client-logos/fusebox.svg";
import vlt from "images/client-logos/vlt.svg";
import um from "images/client-logos/um.svg";
import * as React from 'react';
export default {
  BackgroundText,
  ContentWithLink,
  HomeHeader,
  HomePageHero,
  Logos,
  MeetTheTeam,
  NavBarColorSwitcher,
  Spacer,
  Words,
  planning,
  sofa2,
  tnbt,
  wpserved,
  wupwt,
  insanelab,
  gpd,
  fusebox,
  vlt,
  um,
  React
};